// extracted by mini-css-extract-plugin
module.exports = {"quote":"quote_quote__idEib"};